module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a52bc520f806137fa1d5b818b46c3bc1.png";